import { useOperationsStore } from '@operations/AppProvider'
import { JobSteps } from '@operations/features/equipmentOperator/stores/equipment-operator-work-instruction-stepper.ui-store'
import { observer } from 'mobx-react-lite'
import { GeneralCargoEquipmentOperatorProps } from './confirm-destination.interface'
import { ConfirmAmount } from './ConfirmAmount'
import { FinishOrder } from './FinishOrder'

export const WorkInstructionJobStepper = observer(
  ({ DestinationComponent }: GeneralCargoEquipmentOperatorProps) => {
    const { equipmentOperatorWorkInstructionStepperUIStore } = useOperationsStore()

    return (
      <>
        {equipmentOperatorWorkInstructionStepperUIStore.currentStep === JobSteps.confirmAmount && (
          <ConfirmAmount
            job={equipmentOperatorWorkInstructionStepperUIStore.selectedJob!}
            DestinationComponent={DestinationComponent}
            stepperUiStore={equipmentOperatorWorkInstructionStepperUIStore}
          />
        )}

        {equipmentOperatorWorkInstructionStepperUIStore.currentStep === JobSteps.finishOrder && (
          <FinishOrder
            job={equipmentOperatorWorkInstructionStepperUIStore.selectedJob!}
            stepperUiStore={equipmentOperatorWorkInstructionStepperUIStore}
          />
        )}
      </>
    )
  },
)
